import { formatNumber } from '@lib/utils';

import Button from '@components/button';
import { useListingContext } from '../../context';

import { section_header, details, visitor_stats, listing_courtesy_of } from './styles.module.scss';

const PropertyDetails = () => {
  const {
    features,
    rooms,
    mlsNumber,
    propertyTypeDisplay,
    squareFootage,
    builder,
    county,
    development,
    views,
    listingCourtesyOf
  } = useListingContext();

  return (
    <>
      <h2 className={section_header}>Property Details</h2>
      {features && (
        <div className={details}>
          <ul>
            {mlsNumber && (
              <li>
                <h3>MLS#:</h3> {mlsNumber}
              </li>
            )}
            {propertyTypeDisplay && (
              <li>
                <h3>Type:</h3> {propertyTypeDisplay}
              </li>
            )}
            {!!squareFootage && !!squareFootage !== '0' && (
              <li>
                <h3>Sq. Ft:</h3>
                {formatNumber(squareFootage)}
              </li>
            )}
            {builder?.slug && (
              <li key={builder.slug}>
                <h3>Builder:</h3>
                <Button
                  label={builder.builderDevelopmentName}
                  theme="text-only-red"
                  url={builder.url}
                />
              </li>
            )}
            {county && (
              <li>
                <h3>County:</h3> {county}
              </li>
            )}
            {development?.slug && (
              <li key={development.slug}>
                <h3>Development:</h3>
                <Button
                  label={development.builderDevelopmentName}
                  theme="text-only-red"
                  url={development.url}
                />
              </li>
            )}
            {features.map((feature) => {
              return (
                <li key={feature.name}>
                  <h3>{feature.name}:</h3>
                  {feature.value}
                </li>
              );
            })}
          </ul>
        </div>
      )}
      {rooms.length > 0 && (
        <>
          <h2 className={section_header}>Rooms</h2>
          <div className={details}>
            <ul>
              {rooms.map((room) => {
                return (
                  <li key={room.name}>
                    <h3>{room.name}:</h3>
                    {room.description}
                  </li>
                );
              })}
            </ul>
          </div>
        </>
      )}

      {process.env.NEXT_PUBLIC_VERCEL_ENV === 'production' && (
        <div className={visitor_stats}>
          <div>
            <h3>Online Views:</h3>
            {views}
          </div>
        </div>
      )}

      {listingCourtesyOf && (
        <div className={listing_courtesy_of}>
          <span>This listing courtesy of </span>
          <span>{listingCourtesyOf}</span>
        </div>
      )}
    </>
  );
};

export default PropertyDetails;
